import types from "./actionTypes";
import globalTypes from "../../global/actionTypes";
import * as selectors from "./selectors";
import { flatten } from "./selectors";
import {
	dealWithClusterlets,
	dealWithSections,
	dealWithFields,
	dealWithNetworks,
	dealWithMessages,
	dealWithRrdefs,
	dealWithUserTriggers,
	dealWithInstances,
} from '../../undoredo/actions'

import { findClonedConstrcuts, getDeleteElement, cretaeInstanceForClone, findChildren } from "../../../services/blueprint";
import { clusterletConstructTags, constructIds, cloneClusterletTags, nodesWithProfile } from "../../../config/common";
import { getNetworks, networkForDelegate } from "../networks/selectors";
import { getInstances } from "../bootloaders/selectors";
import { getMessages } from "../messages/selectors";
import { getRoutingRules } from "../routing_rules/selectors";
import { getUserTriggers } from "../user_triggers/selectors";
import { getSections } from "../sections/selectors";
import { getFields } from "../fields/selectors";
import { addSection, editSection, deleteSection } from "../sections/actions";
import { addField, editField, deleteField } from "../fields/actions";
import { addUserTrigger, editUserTrigger, deleteUserTrigger } from "../user_triggers/actions";
import { addMessage, editMessage, deleteMessage } from "../messages/actions";
import { addNetwork, editNetwork, deleteNetwork } from "../networks/actions";
import { addRrdef, editRrdef, deleteRrdef } from "../routing_rules/actions";
import { addInstance, editInstance, deleteInstance } from "../bootloaders/actions";
import { editTransaction } from "../transactions/actions";
import { updatePosition } from "../../undoredo/actions";
import { addClusterletConnection, deleteClusterletConnection } from "../clusterlet_connections/actions";
import { editEvent, deleteEvent } from "../events/actions";
import { getClusterlets, getConstructs } from "../clusterlets/selectors";
import {
	toClusterletData,
	profileData,
	generateConnection,
	addProfileIdToClusterlet,
	toInstanceData,
	generateDelegatePosition,
	generateDigitalTwinPosition,
	generateAnalyticsPosition,
	generateSensorPosition,
	internalSystemConfig,
	findRelativePosition,
	countOfElement
} from "../../../services/reactFlowService";
// import { routingRuleFields } from '../../../config/routing_rules.js'
import { resetInstances } from '../bootloaders/actions';
import { resetClusterletConnections } from '../clusterlet_connections/actions';
import { resetEvents } from '../events/actions';
import { replaceFullFields } from '../fields/actions';
import { resetHandlers } from '../handlers/actions';
import { resetMessages } from '../messages/actions';
import { resetNetworks } from '../networks/actions';
import { resetRoutingRules } from '../routing_rules/actions';
import { replaceFullSections } from '../sections/actions';
import { resetTransactions } from '../transactions/actions';
import { resetUserTriggers } from '../user_triggers/actions';
import { resetUtilityFunctions } from '../utility_functions/actions';
import { resetTemplate } from '../templated_clusterlet/actions';
import { delegateTypes } from "../../../config/common";

const shortUUiD = require("short-uuid");






export const setReactFlowInstance = (payload) => ({
	type: types.SET_REACT_FLOW_INSTANCE,
	payload,
});

export const addClusterlet = (payload, noUndoRedo) => async (dispatch) => {
	const newPayload = JSON.parse(JSON.stringify(payload))
	const relativePosition = await findRelativePosition(newPayload.position, newPayload.type);
	if (noUndoRedo !== true) {
		payload.position = relativePosition;
	}

	if (noUndoRedo != true)
		dispatch(dealWithClusterlets({ ...payload }, 'add'))

	await dispatch({
		type: types.ADD_CLUSTERLET,
		payload: { ...payload },
	})
};

export const editClusterlet = (payload, noUndoRedo, associates) => (dispatch) => {
	if (noUndoRedo != true)
		dispatch(dealWithClusterlets(payload, 'edit', associates))

	dispatch({
		type: types.EDIT_CLUSTERLET,
		payload,
	})
}

export const deleteClusterlet = (payload, noUndoRedo) => dispatch => {
	if (noUndoRedo != true)
		dispatch(dealWithClusterlets(payload, 'delete'))

	dispatch({
		type: types.DELETE_CLUSTERLET,
		payload,
	})
}


export const onDrop = (clusterlet, noUndoRedo) => async (dispatch, getState) => {
	await dispatch(addClusterlet(clusterlet, noUndoRedo));
	const updatedState = getClusterlets(getState());
	return updatedState
}

export const onDragStop = (data, elements) => (dispatch, getState) => {
	
	const clusterlet = data.id
	const index = elements.findIndex(e => e.id === clusterlet)
	const type = elements[index].type;

	const relativePosition = findRelativePosition(data.position, type);
	data.position = relativePosition;

	const editedElement = {
		...elements[index],
		position: { ...elements[index].position, ...data.position }
	}
	
	const payload = editedElement
};


export const onNodeClick = (payload, event, clear) => (dispatch) => {
	// console.log("payload, event, clear", {payload, event, clear})
	dispatch({ type: globalTypes.SELECTED_NODE, payload, event });
};

export const updateSelectedNode = (payload) => ({ type: globalTypes.SELECTED_NODE, ...payload });


export const updateFullClusterlets = (clusterlets) => ({
	type: types.UPDATE_FULL_CLUSTERLETS,
	payload: clusterlets
})

export const checkClusterletInTransactions = (payload) => {
	const { id, transactions } = payload;

	const transactionsWithSelectedClusterlet = transactions?.map(transaction => {
		const clusterletIds = transaction?.clusterlets?.map(element => element.id)
		if (clusterletIds?.includes(id)) return transaction.name
	}).filter(i => i)

	return transactionsWithSelectedClusterlet
}


/**
 * clone functionality for clusterlets in system model and tree view
 */
export const cloneClusterlet = (payload) => async (dispatch, getState) => {


	const { selectedNode, name, sectionParentId } = payload
	const original = JSON.parse(JSON.stringify(selectedNode))
	original.name = name

	/**for cloning section to a different clusterlet */
	let parent = undefined
	if (sectionParentId) {
		original.parent[0].id = sectionParentId
		parent = original?.parent[0]
	}

	// console.log("original", original)

	if (!original.type) original.type = constructIds.find(item => item.type === original.tag).id
	if (!original.tag) original.tag = constructIds.find(item => item.id === original.type).type

	const sectionsInState = getSections(getState());
	const fieldsInState = getFields(getState());



	let nodes = []
	let elements = []

	/**For clone of profile */
	let instancesForClonedNode = []
	let connections = []
	let profileSections = []
	let profileFields = []
	let profiles = []

	//passing to get next count in ids
	if (clusterletConstructTags.includes(original.tag)) {
		elements = selectors.getClusterlets(getState());
	}

	const {
		clusterlet, fields, sections, instance, message, network, rrdef, userTrigger

	} = await findClonedConstrcuts({ original, clusterlets: elements, sectionsInState, fieldsInState, nodes, parent });

	console.log("cloned constructs", { clusterlet, fields, sections, instance, message, network, rrdef, userTrigger })

	if (clusterlet) {
		/**if clusterlet is delegate, clone the instance too */
		if (clusterlet.type === 1) {
			const newInstance = await cretaeInstanceForClone({ instances: getInstances(getState()), original: original, newNode: clusterlet })
			if (Object.keys(newInstance).length > 0) await dispatch(addInstance(newInstance, true))
			instancesForClonedNode.push(newInstance)
		}

		/**if clusterlet has profile, clone the profile, create a new connection and instance */
		if (nodesWithProfile.includes(clusterlet.type) && clusterlet.profile?.length > 0) {

			const cloneProfile = await selectors.getClusterlets(getState()).find(profile => profile.id === clusterlet.profile[0].id)
			const clonedNode = JSON.parse(JSON.stringify(cloneProfile))

			const { clusterlet: profile, fields, sections } = await findClonedConstrcuts({ original: clonedNode, clusterlets: elements, sectionsInState: getSections(getState()), fieldsInState: getFields(getState()), nodes });

			profile.name = `${clusterlet.name}_Profile`
			profile.position = { x: 500, y: 200 }
			delete profile.children

			clusterlet.profile = [{ id: profile.id }]

			profiles.push(profile)
			profileSections = sections
			profileFields = fields
			// console.log({profile, fields, sections, instance, message, network, rrdef, userTrigger })

			if (profile) {
				await dispatch(addClusterlet(profile, true))
			}
			if (sections.length) {
				sections.forEach(async section => {
					await dispatch(addSection(section, true))
				})
			}
			if (fields.length) {
				fields.forEach(async field => {
					await dispatch(addField(field, true))
				})
			}

			/**connection between profile and clusterlet */
			const connection = await generateConnection(clusterlet, profile)
			await dispatch(addClusterletConnection(connection, true))
			connections.push(connection)
			// console.log({connection})


			/**create new instance for profile */
			let newInstance = await cretaeInstanceForClone({ instances: getInstances(getState()), original: cloneProfile, newNode: profile })
			if (Object.keys(newInstance).length > 0) await dispatch(addInstance(newInstance, true))
			instancesForClonedNode.push(newInstance)
			// console.log({newInstance})
		}

		await dispatch(addClusterlet(clusterlet, true))
	}

	if (sections.length) {
		sections.forEach(async section => {
			await dispatch(addSection(section, true))
		})
	}
	if (fields.length) {
		fields.forEach(async field => {
			await dispatch(addField(field, true))
		})
	}
	if (network) {
		await dispatch(addNetwork(network, true))
	}
	if (message) {
		await dispatch(addMessage(message, true))
	}
	if (rrdef) {
		await dispatch(addRrdef(rrdef, true))
	}
	if (userTrigger) {
		await dispatch(addUserTrigger(userTrigger, true))
	}
	if (instance) {
		await dispatch(addInstance(instance, true))
	}

	/**undo redo operations */
	const payloadForUndoRedo = {
		clonedItem: selectedNode.id, clusterlet, fields, sections,
		instance, message, network, rrdef, userTrigger, instancesForClonedNode,
		connections, profileSections, profileFields, profiles
	}

	if (cloneClusterletTags.includes(original.tag)) {
		await dispatch(dealWithClusterlets(payloadForUndoRedo, "clone"))
	}

	if (original.tag === "section") {
		await dispatch(dealWithSections(payloadForUndoRedo, "clone"))
	}

	if (original.tag === "field") {
		await dispatch(dealWithFields(payloadForUndoRedo, "clone"))
	}

	if (original.tag === "network") {
		await dispatch(dealWithNetworks(payloadForUndoRedo, "clone"))
	}

	if (original.tag === "message") {
		await dispatch(dealWithMessages(payloadForUndoRedo, "clone"))
	}

	if (original.tag === "rrdef") {
		await dispatch(dealWithRrdefs(payloadForUndoRedo, "clone"))
	}

	if (original.tag === "user_trigger") {
		await dispatch(dealWithUserTriggers(payloadForUndoRedo, "clone"))
	}

	if (original.tag === "instance") {
		await dispatch(dealWithInstances(payloadForUndoRedo, "clone"))
	}
}

const deleteElementAssociates = async (payload) => {
	const { deleteElement, elements, sections, fields } = payload
	const nodeAndChildren = await findChildren(deleteElement, elements, sections, fields)

	const children = await flatten([], JSON.parse(JSON.stringify(nodeAndChildren.children)))

	const nodeAssociatedFields = children.filter(item => item.type === 12)

	const nodeAssociatedSections = children.filter(item => item.type === 11)

	return {
		nodeAssociatedFields,
		nodeAssociatedSections
	}

}



export const deleteNodeAndAssociates = (payload) => async (dispatch, getState) => {
	// console.log({payload})
	const { node } = payload
	if (!node.tag) node.tag = constructIds.find(item => item.id === node.type).type

	if (clusterletConstructTags.includes(node.tag)) {

		const {
			item,
			connections,
			sections,
			profileConnections,
			sectionFields,
			instances,
			profiles,
			profileFields,
			profileSections,
			profileInstances,
			undoRedoEventData,
			clusterletEdited,
			events,
			editTransactions,
			rrdefs,
			userTriggers,
			transactionsBeforeEdit
		} = await selectors.getDeletedElementAssociates({ item: node, state: selectors.getConstructs(getState()) })


		await dispatch(deleteClusterlet(item, true))

		await connections?.forEach(async edge => {
			await dispatch(deleteClusterletConnection({ item: edge, connetedTemplate: [] }, true))
		})

		await profileConnections?.forEach(async edge => {
			await dispatch(deleteClusterletConnection({ item: edge, connetedTemplate: [] }, true))
		})

		await sectionFields?.forEach(async field => {
			await dispatch(deleteField(field, true))
		})

		await sections?.forEach(async section => {
			await dispatch(deleteSection(section, true))
		})

		await rrdefs?.forEach(async rrdef => {
			await dispatch(deleteRrdef(rrdef, true))
		})

		await userTriggers?.forEach(async ut => {
			await dispatch(deleteUserTrigger(ut, true))
		})

		await profiles?.forEach(async profile => {
			await dispatch(deleteClusterlet(profile, true))
		})

		await instances?.forEach(async instance => {
			await dispatch(deleteInstance(instance, true))
		})

		await profileFields?.forEach(async profileField => {
			await dispatch(deleteField(profileField, true))
		})

		await profileSections?.forEach(async profileSection => {
			await dispatch(deleteSection(profileSection, true))
		})

		await profileInstances?.forEach(async profileInstance => {
			await dispatch(deleteInstance(profileInstance, true))
		})

		await events?.forEach(async event => {
			await dispatch(deleteEvent(event, true))
		})

		await editTransactions?.forEach(async trans => {
			await dispatch(editTransaction(trans, true))
		})

		if (node.tag === "profile") {
			await dispatch(editClusterlet(clusterletEdited, true))
		}
		let networkToDelete;
		if (node.tag === 'external_function') {
			networkToDelete = await dispatch(deleteUnusedNetork(node));
		}


		/**
		 * for undo redo
		 */
		const payload = {
			item,
			connections,
			sections,
			profileConnections,
			sectionFields,
			instances,
			profiles,
			profileFields,
			profileSections,
			profileInstances,
			undoRedoEventData,
			clusterletEdited,
			events,
			rrdefs,
			userTriggers,
			network: networkToDelete,
			transactionsBeforeEdit
		}
		delete payload.item.tag;
		await dispatch(dealWithClusterlets(payload, "delete"))

	}

	if (node.tag === "section") {

		/**selected node */
		const deleteElement = await getDeleteElement(getSections(getState()), JSON.parse(JSON.stringify(node)))

		/**find associated fields */
		const {
			nodeAssociatedFields,
		} = await deleteElementAssociates({ deleteElement: JSON.parse(JSON.stringify(deleteElement)), elements: getSections(getState()), sections: getSections(getState()), fields: getFields(getState()) })

		/**delete associated fields */
		nodeAssociatedFields?.forEach(async field => {
			await dispatch(deleteField(field, true))
		})

		/**delete the node selected to delete */
		await dispatch(deleteSection(deleteElement, true))

		/**deal with sections for undoredo */
		const payload = {
			item: deleteElement,
			nodeAssociatedFields,
		}
		delete payload.item.tag;
		await dispatch(dealWithSections(payload, "delete"))

	}

	if (node.tag === "field") {
		const deleteElement = await getDeleteElement(getFields(getState()), JSON.parse(JSON.stringify(node)))

		/**find associated fields */
		const {
			nodeAssociatedFields,
		} = await deleteElementAssociates({ deleteElement: JSON.parse(JSON.stringify(deleteElement)), elements: getFields(getState()), sections: getSections(getState()), fields: getFields(getState()) })

		/**delete associated fields */
		nodeAssociatedFields?.forEach(async field => {
			await dispatch(deleteField(field, true))
		})

		/**delete the node selected */
		await dispatch(deleteField(deleteElement, true))

		/**deal with sections for undoredo */
		const payload = {
			item: deleteElement,
			nodeAssociatedFields,
		}
		delete payload.item.tag;
		await dispatch(dealWithFields(payload, "delete"))

	}

	if (node.tag === "message") {

		const deleteElement = await getDeleteElement(getMessages(getState()), JSON.parse(JSON.stringify(node)))

		/**find associated fields */
		const {
			nodeAssociatedFields,
		} = await deleteElementAssociates({ deleteElement: JSON.parse(JSON.stringify(deleteElement)), elements: getMessages(getState()), sections: getSections(getState()), fields: getFields(getState()) })

		/**delete associated fields */
		nodeAssociatedFields?.forEach(async field => {
			await dispatch(deleteField(field, true))
		})

		/**delete the node selected */
		await dispatch(deleteMessage(deleteElement, true))

		/**deal with sections for undoredo */
		const payload = {
			item: deleteElement,
			nodeAssociatedFields,
		}
		delete payload.item.tag;
		await dispatch(dealWithMessages(payload, "delete"))

	}

	if (node.tag === "user_trigger") {
		const deleteElement = await getDeleteElement(getUserTriggers(getState()), JSON.parse(JSON.stringify(node)))

		/**find associated fields */
		const {
			nodeAssociatedFields,
		} = await deleteElementAssociates({ deleteElement: JSON.parse(JSON.stringify(deleteElement)), elements: getUserTriggers(getState()), sections: getSections(getState()), fields: getFields(getState()) })

		/**delete associated fields */
		nodeAssociatedFields?.forEach(async field => {
			await dispatch(deleteField(field, true))
		})

		/**delete the node selected */
		await dispatch(deleteUserTrigger(deleteElement, true))

		/**deal with sections for undoredo */
		const payload = {
			item: deleteElement,
			nodeAssociatedFields,
		}
		delete payload.item.tag;
		await dispatch(dealWithUserTriggers(payload, "delete"))

	}

	if (node.tag === "rrdef") {
		const deleteElement = await getDeleteElement(getRoutingRules(getState()), node)
		delete deleteElement.tag
		await dispatch(deleteRrdef(deleteElement))
	}

	if (node.tag === "network") {
		const deleteElement = await getDeleteElement(getNetworks(getState()), node)
		delete deleteElement.tag
		await dispatch(deleteNetwork(deleteElement))
	}

	if (node.tag === "instance") {

		const deleteElement = await getDeleteElement(getInstances(getState()), node)

		const associatedUserTriggers = getUserTriggers(getState()).filter(item => {
			if (item.attributes?.instance && item.attributes.instance === node.id) return item
		})

		associatedUserTriggers?.forEach(async userTrigger => {
			await dispatch(deleteUserTrigger(userTrigger, true))
		})

		await dispatch(deleteInstance(deleteElement, true))


		const payload = {
			item: deleteElement,
			userTriggers: associatedUserTriggers
		}

		delete payload.item.tag;
		await dispatch(dealWithInstances(payload, "delete"))

	}

}

export const addProfile = (selectedClusterlet) => async (dispatch, getState) => {

	const clusterlets = getClusterlets(getState());

	const profile = await profileData("profile", selectedClusterlet, clusterlets)
	await dispatch(addClusterlet(profile, true))

	//const connectionString = await generateConnection(data, profile)
	// console.log("connectionString", connectionString)

	//await dispatch(addClusterletConnection(connectionString, true))

	//adding the profile id to clusterlet
	const editedClusterlet = addProfileIdToClusterlet(selectedClusterlet.id, profile.id, clusterlets)
	await dispatch(editClusterlet(editedClusterlet, true));


	const instanceData = toInstanceData(profile)
	console.log({ instanceData })
	await dispatch(addInstance(instanceData, true))

	//deal with clusterlet for undoredo
	const payload = profile
	await dispatch(dealWithClusterlets(payload, 'add'))

	return profile;

}

export const changeDelegateType = (editedDelegate, type) => async (dispatch, getState) => {
	try {

		const bootloaders = getInstances(getState());
		const constructs = getConstructs(getState());
		const instance = bootloaders.find(item => item?.attributes?.type === editedDelegate?.id);
		let originalRrdefs = [];
		let editedRrdefs = []
		const delegateChangedependencies = {};

		if (type !== undefined) {

			let rrdefFields = { fields: [] };
			const rrdefForDelegate = getRoutingRules(getState()).filter(rrdef => rrdef?.attributes?.delegate === editedDelegate.id)
			originalRrdefs = JSON.parse(JSON.stringify(rrdefForDelegate))

			rrdefForDelegate.forEach(rrdef => {
				// const rrdefFields = routingRuleFields.find(rrdefField => rrdefField.type === type && rrdefField.direction === rrdef?.attributes.dir);
				// const rrdefObj = delegateTypes.find(rrdefField => rrdefField.value === type  && rrdefField.rrdef.find(rr => rr.direction == rrdef?.attributes.dir));
				const rrdefObj = delegateTypes.find(elem => elem.value === type && elem.rrdef.some(def => def.direction === rrdef?.attributes.dir));

				if (rrdefObj) {
					rrdefFields = rrdefObj.rrdef.find(def => def.direction === rrdef?.attributes.dir);
				}

				for (const item in rrdef?.attributes) {

					if (!(rrdefFields?.fields.includes(item))) {
						delete rrdef?.attributes[item]
					}
				}


				//dispatch(editRrdef(rrdef, true))
				const newRrdef = {
					...rrdef,
					id: shortUUiD.generate()
				}

				if (Object.keys(newRrdef.attributes).length > 0) {
					console.log({ newRrdef })
					editedRrdefs.push(newRrdef)
					dispatch(addRrdef(newRrdef, true))
					dispatch(deleteRrdef(rrdef, true))
				}
				else {
					dispatch(deleteRrdef(rrdef, true))

				}


			})

			delegateChangedependencies.originalrrdefs = originalRrdefs;
			delegateChangedependencies.editedrrdefs = editedRrdefs;

		}
		const externalFunctions = selectors.getExternalFunctions(getState());
		const delegateBeforeEdit = externalFunctions.find(i => i.id === editedDelegate.id);

		let networkToDelete;

		const { networkExists, network: networkObj } = networkForDelegate({ editedDelegate, constructs })
		// console.log('networkExists--->', { networkExists, networkObj })

		if (networkExists) dispatch(editNetwork(networkObj, true))

		if (!networkExists) dispatch(addNetwork(networkObj, true));
		editedDelegate.attributes.network = networkObj.id

		// console.log('edit after addition---->', { editedDelegate, delegateBeforeEdit });

		if (networkObj?.id !== delegateBeforeEdit?.attributes?.network) {
			networkToDelete = await dispatch(deleteUnusedNetork(delegateBeforeEdit));
		}

		// console.log('delete netwrk---->', networkToDelete)

		const networkDetails = { original: networkToDelete, edited: networkObj };
		delegateChangedependencies.network = networkDetails;

		console.log('edited----->', editedDelegate)
		dispatch(editClusterlet({ ...editedDelegate }, undefined, delegateChangedependencies))


		// instance.name = networkObj.name;
		instance.attributes.networks = [networkObj.name]

		dispatch(editInstance(instance, true));

	}
	catch (error) {
		// console.log("error----->", error)
	}
}

export const deleteUnusedNetork = (node) => async (dispatch, getState) => {

	const externalFunctions = await selectors.getExternalFunctions(getState());
	const networkFlag = externalFunctions.find(i => i.attributes.network === node.attributes.network && i.id !== node.id)
	let networkToDelete;
	if (networkFlag === undefined) {
		const networks = getNetworks(getState());
		networkToDelete = networks.find(i => i.id === node.attributes.network);
		await dispatch(deleteNetwork(networkToDelete, true));
	}
	return networkToDelete;
}


export const resetClusterlets = (clusterlets) => ({
	type: types.RESET_CLUSTERLETS,
	payload: clusterlets
})

export const resetBlueprintConstructs = () => async (dispatch, getState) => {
	
	return Promise.all([
		dispatch(resetInstances([])),
		dispatch(resetClusterlets([])),
		dispatch(resetClusterletConnections([])),
		dispatch(resetEvents([])),
		dispatch(replaceFullFields([])),
		dispatch(resetHandlers([])),
		dispatch(resetMessages([])),
		dispatch(resetNetworks([])),
		dispatch(resetRoutingRules([])),
		dispatch(replaceFullSections([])),
		dispatch(resetTransactions([])),
		dispatch(resetUserTriggers([])),
		dispatch(resetUtilityFunctions({})),
		dispatch(resetTemplate([]))
	]);
}



